import { OPPORTUNITY_TYPES } from '../../constants';
import { Discover } from 'src/util';
import { Chip } from '@inpart-io/react-components';

type OpportunityIconChipProps = {
  type: Discover.OpportunityTypeName;
  singular?: boolean;
  labelOverride?: string;
};

/**
 * Returns the chip for the specified opportunity type
 */
export const OpportunityIconChip: React.ElementType<OpportunityIconChipProps> = ({
  type,
  singular = false,
  labelOverride,
  ...props
}) => {
  const { IconNew, label, labelSingular } = OPPORTUNITY_TYPES[type];

  return (
    <Chip IconLeft={<IconNew />} {...props}>
      {labelOverride ? labelOverride : singular ? labelSingular : label}
    </Chip>
  );
};
